import { Particle } from "../Particle";
import { MovesDown } from "../behaviors/MovesDown";
import { TemperatureNormalization } from "../behaviors/TemperatureNormalization";
import { PhaseChange } from "../behaviors/PhaseChange";
import { adjustColor } from "../../utils/color";
import { Fire } from "./Fire";
import { Lava } from "./Lava";
import { Gunpowder } from "./Gunpowder";
import { ChemicalReaction } from "../behaviors/ChemicalReaction";

export class Sulfur extends Particle {
    static baseColor = 0xEEDD00; // Bright Yellow

    constructor() {
        super({
            name: "Sulfur",
            color: adjustColor(Sulfur.baseColor, 15),
            behaviors: [
                new MovesDown(),
                new ChemicalReaction(['Saltpeter', 'Charcoal'], () => new Gunpowder(), 0.05),
                new TemperatureNormalization(20, 0.1),
                // 硫磺熔点低 (115C)，且易燃
                new PhaseChange([
                    {
                        temp: 115,
                        type: 'above',
                        // 熔化后变成火/熔岩混合物，这里简化为直接燃烧或者变成高温熔岩
                        // 为了表现易燃性，让它变成火
                        factory: () => new Fire() 
                    }
                ])
            ],
            temperature: 20,
            minTemp: -273,
            maxTemp: 1000,
            props: {
                isPowder: true,
                isFlammable: true
            }
        });
    }
}
